import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import BrandsInfo, { DispatchProps, StateProps } from 'components/pages/brand/BrandsInfo';

import {  BrandInfoAction, sendBrandsDataRequest } from 'redux/modules/brand-info';

const mapStateToProps = (state: IRootState): StateProps => {
    return {
        brands: state.brandInfo.brands,
        fetchFailed: state.brandInfo.failed,
        isMobile: state.display.isMobile,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<BrandInfoAction>): DispatchProps => {
    return {
        loadBrandsInfo: () => dispatch<any>(sendBrandsDataRequest())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandsInfo);



// WEBPACK FOOTER //
// ./src/containers/pages/brand/BrandsInfo.tsx